import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer
      data-testid="footer"
      className="mt-24"
      style={{
        background: "var(--footer-bg)",
        color: "var(--footer-text)",
      }}
    >
      <div className="max-w-6xl mx-auto px-6 md:px-10 py-14 grid md:grid-cols-3 gap-10">
        <div>
          <div className="font-serif text-3xl" style={{ color: "var(--footer-text)" }}>
            saamne
          </div>
          <p className="mt-3 text-sm leading-relaxed" style={{ color: "var(--footer-text)", opacity: 0.85 }}>
            A startup running in-person experiences (only) across Hyderabad, Bangalore and Pune — coffee, films, nature walks, senior getaways and lifeskill workshops.
          </p>
          <p className="mt-4 font-serif italic text-lg" style={{ color: "var(--footer-tagline)" }} data-testid="footer-tagline">
            saamne — not an events company. we're in the business of human connection.
          </p>
        </div>
        <div>
          <div className="label-eyebrow" style={{ color: "var(--footer-text)", opacity: 0.65 }}>Wander</div>
          <ul className="mt-3 space-y-2 text-sm">
            <li><Link to="/propose" className="hover:opacity-100" style={{ color: "var(--footer-text)", opacity: 0.85 }} data-testid="footer-link-propose">Suggest a Gathering</Link></li>
            <li><Link to="/copartner" className="hover:opacity-100" style={{ color: "var(--footer-text)", opacity: 0.85 }} data-testid="footer-link-copartner">Partner with us</Link></li>
            <li><Link to="/join" className="hover:opacity-100" style={{ color: "var(--footer-text)", opacity: 0.85 }} data-testid="footer-link-join">Host with us</Link></li>
            <li><Link to="/about" className="hover:opacity-100" style={{ color: "var(--footer-text)", opacity: 0.85 }} data-testid="footer-link-about">Our Story</Link></li>
          </ul>
        </div>
        <div>
          <div className="label-eyebrow" style={{ color: "var(--footer-text)", opacity: 0.65 }}>Reach us</div>
          <p className="mt-3 text-sm" style={{ color: "var(--footer-text)", opacity: 0.85 }}>
            Want to host a gathering, or know someone who should?
          </p>
          <a
            href="mailto:hello@saamne.com"
            data-testid="footer-email"
            className="mt-3 inline-block text-sm font-medium"
            style={{ color: "var(--accent-2)" }}
          >
            hello@saamne.com
          </a>
        </div>
      </div>
      <div className="max-w-6xl mx-auto px-6 md:px-10 pb-8 text-xs flex items-center justify-between"
           style={{ color: "var(--footer-text)", opacity: 0.6 }}>
        <span>© {new Date().getFullYear()} saamne · Hyderabad · Bangalore · Pune</span>
        <span>Made slowly, on purpose.</span>
      </div>
    </footer>
  );
}
